import { types, flow, Instance, applySnapshot } from 'mobx-state-tree';

import { getCriterias } from './apiWrappers/wrappers/useCriteria';

import { filterCriteriasDataByOrigin, getCriteriasUrlByOrigin } from '../utils/utilsFunctions';

const CriteriaMeta = types.model('CriteriaMeta', {
  relatedSegments: types.maybeNull(types.array(types.string)),
  relatedPlanLabels: types.maybeNull(types.array(types.string)),
  iconUrl: types.maybeNull(types.string),
  type: types.maybeNull(types.string),
});

const CriteriaModel = types.model('CriteriaModel', {
  id: types.identifier,
  type: types.string,
  name: types.string,
  label: types.string,
  priority: types.number,
  description: types.maybeNull(types.string),
  meta: CriteriaMeta,
});

interface Criteria extends Instance<typeof CriteriaModel> {}

const CriteriaStoreModel = types
  .model('CriteriaStoreModel', {
    criterias: types.array(CriteriaModel),
  })
  .views((self) => ({
    getCriteriasByType(type: string) {
      return self.criterias.filter((item) => item.type === type).sort((a, b) => b.priority - a.priority);
    },
  }))
  .actions((self) => ({
    getCriterias: flow(function* fetchData(origin: string | null) {
      if (!!origin) {
        const url = getCriteriasUrlByOrigin(origin);
        const { kind, data } = yield getCriterias(url);
        if (kind === 'ok') {
          applySnapshot(self, { ...self, criterias: filterCriteriasDataByOrigin({ origin, data }) });
        }
      }
    }),
  }));

export { CriteriaModel, CriteriaStoreModel, Criteria, CriteriaMeta };
